export const API_INVALID_VALUE = -2147483648;
